import React, { Fragment } from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Box,
  CardMedia,
  Typography
} from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { baseUrl } from '../../../axios';
import { useForm } from 'react-hook-form';
import Colors from '../../Assets/Styles/Colors';

export default function FormDialog(props) {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { open, handleClose, title, label, type, handleFileUpload, image, action, name, setName } = props;
  console.log("🚀 ~ FormDialog ~ label:", label)
  console.log("🚀 ~ FormDialog ~ type:", type)

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        component={"form"}
        onSubmit={handleSubmit(action)}
        PaperProps={{
          style: {
            width: "400px !important",
            height: "400px !important"
          }
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Grid container rowSpacing={2}>
            <Grid item md={12}>
              <Box>
                <TextField
                  autoFocus
                  label={label}
                  fullWidth
                  value={name}
                  variant="standard"
                  {...register("name", {
                    required: `Please enter ${label}`,
                    onChange: (e) => setName(e.target.value),
                  })}
                  helperText={errors?.name?.message}
                  error={errors?.name && true}
                />
              </Box>
            </Grid>
            {(label == "Category Name" || label == "Service Name") && (type == "adbazaar" || type == "adpro") && (
              <Grid item md={12}>
                {image ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CardMedia
                      component={"img"}
                      src={baseUrl + image}
                      sx={{
                        width: "150px",
                        height: "120px",
                        objectFit: "contain"
                      }}
                    />
                  </Box>
                ) : (
                  <Fragment>
                    <input
                      multiple
                      type="file"
                      accept="image/*"
                      style={{
                        opacity: "0",
                        outline: "none",
                        background: "white",
                        cursor: "inherit",
                        display: "none",
                      }}
                      id="uploadImages"
                      onInput={(event) => {
                        handleFileUpload(event.target.files[0]);
                      }}
                      {...register("image", {
                        required:
                          image == "" ? "upload image" : false,
                      })}
                    />
                    <label
                      htmlFor="uploadImages"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        width: "100%",
                        height: "200px",
                        border: errors?.image?.message
                          ? `1px solid ${Colors.primary}`
                          : "1px solid #c4c4c4",
                        borderRadius: "4px",
                      }}
                    >
                      <CloudUpload
                        sx={{
                          display: "block",
                          fontSize: "38px",
                          color: errors?.image?.message
                            ? "#d32f2f"
                            : Colors.success,
                          cursor: "pointer",
                          "&:hover": {
                            color: Colors.secondary,
                            transition: "0.3s ease-in-out",
                          },
                        }}
                      />
                      <Typography
                        sx={{
                          color: errors?.image?.message ? "#d32f2f" : Colors.gray,
                        }}
                      >
                        {errors?.image ? errors?.image?.message : "Upload Image"}
                      </Typography>
                    </label>
                  </Fragment>
                )}
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">Submit</Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}